// Locations screen (package flag `multi_location`).
export const locationsEn = {
  'layout.nav.locations': 'Locations',
  'locations.subtitle': 'Each published location gets its own page, opening hours and Google markup at /locations/<address>.',
  'locations.locked': 'Your plan does not include multiple locations.',
  'locations.empty': 'No locations yet.',
  'locations.add': 'Add location',
  'locations.remove': 'Remove',
  'locations.moveUp': 'Move up',
  'locations.unnamed': 'Untitled location',
  'locations.draft': 'Draft',
  'locations.saved': 'Locations saved',
  'locations.f.name': 'Name',
  'locations.f.slug': 'Page address',
  'locations.f.slugHint': 'Lowercase letters, numbers and hyphens. The page will be at /locations/<address>.',
  'locations.f.slugFromName': 'Fill from name',
  'locations.f.published': 'Published',
  'locations.f.summary': 'Short description',
  'locations.f.phone': 'Phone',
  'locations.f.email': 'Email',
  'locations.f.mapUrl': 'Map link',
  'locations.f.mapUrlHint': 'An https link to the place in Google Maps or another map app.',
  'locations.f.image': 'Photo',
  'locations.f.street': 'Street',
  'locations.f.city': 'City',
  'locations.f.region': 'Region',
  'locations.f.postalCode': 'Postal code',
  'locations.f.country': 'Country',
} as const

export const locationsId: Record<keyof typeof locationsEn, string> = {
  'layout.nav.locations': 'Lokasi',
  'locations.subtitle': 'Setiap lokasi yang diterbitkan mendapat halaman sendiri, jam buka, dan markup Google di /locations/<alamat>.',
  'locations.locked': 'Paket Anda tidak mencakup beberapa lokasi.',
  'locations.empty': 'Belum ada lokasi.',
  'locations.add': 'Tambah lokasi',
  'locations.remove': 'Hapus',
  'locations.moveUp': 'Naikkan',
  'locations.unnamed': 'Lokasi tanpa judul',
  'locations.draft': 'Draf',
  'locations.saved': 'Lokasi disimpan',
  'locations.f.name': 'Nama',
  'locations.f.slug': 'Alamat halaman',
  'locations.f.slugHint': 'Huruf kecil, angka, dan tanda hubung. Halaman akan berada di /locations/<alamat>.',
  'locations.f.slugFromName': 'Isi dari nama',
  'locations.f.published': 'Diterbitkan',
  'locations.f.summary': 'Deskripsi singkat',
  'locations.f.phone': 'Telepon',
  'locations.f.email': 'Email',
  'locations.f.mapUrl': 'Tautan peta',
  'locations.f.mapUrlHint': 'Tautan https ke tempat di Google Maps atau aplikasi peta lain.',
  'locations.f.image': 'Foto',
  'locations.f.street': 'Jalan',
  'locations.f.city': 'Kota',
  'locations.f.region': 'Wilayah',
  'locations.f.postalCode': 'Kode pos',
  'locations.f.country': 'Negara',
}
